import React, {useEffect} from 'react';
import Modal from 'react-modal';
import {FormComponentV2} from "./Components/FormComponentV2";

const customStyles = {
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        width: '60%',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root');

export const FormModal = ({isModalOpen, title, entity, id, onSaveAction, onCancelAction}) => {

    const [modalIsOpen, setIsOpen] = React.useState(isModalOpen);


    useEffect(() => {
        setIsOpen(isModalOpen);
    }, [isModalOpen])


    function afterOpenModal() {
    }

    function closeModal() {
        setIsOpen(false);
    }

    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <h2>{title}</h2>
                <FormComponentV2 entity={entity} id={id} onSaveAction={onSaveAction} onCancelAction={onCancelAction}/>
            </Modal>
        </div>
    );

}
